import axios from "axios";
const BACKEND_URL = import.meta.env.VITE_BACKEND_URL || "http://localhost:4000";
const BASE_URL = `${BACKEND_URL}/api/v1`;

export const getJornadas = async (token) => {
  const res = await axios.get(`${BASE_URL}/jornadas`, { headers: { Authorization: `Bearer ${token}` } });
  return res.data;
};

export const createJornada = async (token, data) => {
  const res = await axios.post(`${BASE_URL}/jornadas`, data, { headers: { Authorization: `Bearer ${token}` } });
  return res.data;
};

export const updateJornada = async (token, id, data) => {
  const res = await axios.put(`${BASE_URL}/jornadas/${id}`, data, { headers: { Authorization: `Bearer ${token}` } });
  return res.data;
};

export const deleteJornada = async (token, id) => {
  const res = await axios.delete(`${BASE_URL}/jornadas/${id}`, { headers: { Authorization: `Bearer ${token}` } });
  return res.data;
};

export const asociarJornadaEmpleado = async (token, userId, jornadaId) => {
  const res = await axios.post(`${BASE_URL}/jornadas/asociar-empleado`, { userId, jornadaId }, { headers: { Authorization: `Bearer ${token}` } });
  return res.data;
};
